import { defineStore } from 'pinia'
import { shallowRef } from '@vue/composition-api'
import { fetchAllSports } from '@ms/api/match'
import usePrematchSports from './lib/usePrematchSports.js'
import { batchUpdateSportsMap } from './map.js'
import useSportsAvailable from './sportsAvailable'

// 公共 sports store
export const useSportsStore = defineStore('commonSports', () => {
  // 站内支持的体育项目，不一定显示在页面中
  const sportsSupported = shallowRef([])
  const fetchSupportSports = async () => {
    const sports = await fetchAllSports()
    if (!sports) return
    sportsSupported.value = sports
    batchUpdateSportsMap(sports)
  }

  const prematchSportStore = usePrematchSports()
  const sportsAvailableStore = useSportsAvailable()

  return {
    sportsSupported,
    fetchSupportSports,
    ...prematchSportStore,
    ...sportsAvailableStore
  }
})
